document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('js-notice');

  if (run.length > 0) {
    const notice = document.querySelector('.js-notice');

    window.atlas = window.atlas || {};

    window.atlas.notify = (message) => {
      notice.classList.remove('hidden');
      const messageContainer = document.querySelector('.js-notice').querySelector('.notice');

      messageContainer.innerHTML = message;

      setTimeout(() => {
        notice.classList.add('hidden');
      }, 5000);
    };

  }
});
